const DOMAIN_CONFIG = {
  'desk.pdic.support': {
    tenant_code: 'PDIC',
    app_name: 'PDIC Support',
    logo_url: '/uploads/photos/3cbc7462-d263-44d2-929d-875b0a350783.jpeg',
    primary_color: '#1B6B3A',
    placeholder: 'PDIC'
  },
  'complaint.pdic.support': {
    tenant_code: 'PDIC',
    app_name: 'PDIC',
    logo_url: '/uploads/photos/3cbc7462-d263-44d2-929d-875b0a350783.jpeg',
    primary_color: '#1B6B3A',
    placeholder: 'PDIC'
  },
  'desk.fibralink.co.in': {
    tenant_code: '',
    app_name: 'FibraDesk',
    logo_url: '',
    primary_color: '#1B6B3A',
    placeholder: 'e.g. FIBRA'
  },
  'default': {
    tenant_code: '',
    app_name: 'FibraDesk',
    logo_url: '',
    primary_color: '#1B6B3A',
    placeholder: 'Enter tenant code'
  }
};

export const getDomainConfig = () => {
  const hostname = window.location.hostname;
  console.log("Current hostname:", hostname);
  console.log("Config found:", DOMAIN_CONFIG[hostname] ? "YES" : "NO - using default");
  console.log("App name:", (DOMAIN_CONFIG[hostname] || DOMAIN_CONFIG["default"]).app_name);
  return DOMAIN_CONFIG[hostname] || DOMAIN_CONFIG['default'];
};
